export const WHATSAPP_PHONE = "556536820700";

export const DEFAULT_WHATSAPP_MESSAGE =
  "Olá cheguei aqui atráves do anúncio e gostaria de fazer um orçamento";

export function buildWhatsAppLink(message: string = DEFAULT_WHATSAPP_MESSAGE): string {
  return `https://wa.me/${WHATSAPP_PHONE}?text=${encodeURIComponent(message)}`;
}

export function buildProductWhatsAppMessage(productName: string): string {
  return `${DEFAULT_WHATSAPP_MESSAGE} do produto ${productName}.`;
}
